export default __webpack_public_path__ + "static/media/Huawei.883ac6c7.png";